export const CHANGE_TYPES = [
  "Pay rate / salary", "Promotion / job title", "Department / transfer", "Supervisor / work location",
  "Employment status / classification", "Standard hours / schedule", "One-time payment",
  "Recurring earning / deduction", "Leave / return from leave", "Termination", "Direct deposit / tax form", "Other",
];
export const EMPLOYMENT_STATUS = ["Full-Time", "Part-Time", "Temporary", "Seasonal", "Other"];
export const PAY_FREQ = ["Weekly", "Biweekly", "Semimonthly", "Monthly", "Other"];
export const JOB_ROWS = [
  ["department", "Department / Cost Center"], ["job_title", "Job Title / Position"], ["supervisor", "Supervisor / Manager"],
  ["work_location", "Work Location / Remote Status"], ["employment_class", "Employment Class"], ["flsa", "FLSA Status"],
  ["schedule", "Standard Hours / Schedule"],
];
export const PAY_BASIS = ["Hourly", "Salary", "Commission", "Other"];
export const ADJ_TYPES = ["Bonus", "Commission", "Retroactive pay", "Reimbursement", "Allowance / stipend", "PTO payout", "Recurring earning", "Recurring deduction", "Other"];
export const ADJ_FREQ = ["One-time", "Each payroll", "Monthly"];
export const LEAVE_ACTIONS = ["Leave", "Return", "Termination"];
export const LEAVE_PAY = ["Paid", "Unpaid", "Mixed"];
export const TERM_CATEGORY = ["Voluntary", "Involuntary", "Retirement"];
export const DOCS = ["Compensation approval", "Commission / bonus detail", "Direct deposit authorization", "Tax withholding form", "Leave documentation", "Termination notice", "Employee acknowledgment", "Other"];
export const INTERNAL_APPROVALS = ["Supervisor / Manager", "Department Head / Owner", "Human Resources"];

export const STATUS_META = {
  submitted: { label: "Submitted", cls: "bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-300" },
  in_review: { label: "In Review", cls: "bg-indigo-100 text-indigo-700 dark:bg-indigo-500/15 dark:text-indigo-300" },
  on_hold: { label: "On Hold", cls: "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300" },
  returned: { label: "Returned", cls: "bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-300" },
  declined: { label: "Declined", cls: "bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300" },
  completed: { label: "Completed", cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300" },
};

export const EMPTY_FORM = {
  date_submitted: new Date().toISOString().slice(0, 10), requested_by: "",
  employee_name: "", employee_id: "", department: "", job_title: "", work_location: "", supervisor: "",
  effective_date: "", pay_period_effective: "", employment_status: "", employment_status_other: "", pay_frequency: "", pay_frequency_other: "",
  change_types: [], change_type_other: "",
  job_changes: {}, // { field: { current, new } }
  new_pay_basis: "", overtime_eligible: "", current_rate: "", new_rate: "", current_pay_frequency: "", new_pay_frequency: "", change_amount: "", retro_date: "",
  adjustment_types: [], adjustment_other: "", adj_amount: "", adj_frequency: "", adj_dates: "", adj_hours: "", adj_code: "", adj_gl: "",
  leave_action: "", leave_pay_status: "", last_day_worked: "", leave_effective_date: "", return_date: "", final_pay_date: "", termination_category: "", pto_payout: "",
  documents: [], documents_other: "",
  justification: "",
};

export function StatusPill({ status }) {
  const m = STATUS_META[status] || { label: status, cls: "bg-muted text-muted-foreground" };
  return <span data-testid={`status-pill-${status}`} className={`inline-flex px-2 py-0.5 rounded-md text-xs font-semibold ${m.cls}`}>{m.label}</span>;
}
